import Rails from '@rails/ujs';
import { Turbo } from '@hotwired/turbo-rails';
import '../portal/application.scss';
import { InitializationHelpers } from '../portal/portalHelpers';
import { initializeOnseasonAnalytics } from 'onseason/analytics';

Rails.start();
Turbo.start();
initializeOnseasonAnalytics();

document.addEventListener('turbo:load', InitializationHelpers.onLoad);
